"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mandolin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1.343-dev.d889c8c
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoAssetsApi = exports.VideoAssetsApiFactory = exports.VideoAssetsApiFp = exports.VideoAssetsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * VideoAssetsApi - axios parameter creator
 * @export
 */
exports.VideoAssetsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateVideoAssetDTO} createVideoAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAsset: (createVideoAssetDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createVideoAssetDTO' is not null or undefined
            if (createVideoAssetDTO === null || createVideoAssetDTO === undefined) {
                throw new base_1.RequiredError('createVideoAssetDTO', 'Required parameter createVideoAssetDTO was null or undefined when calling adminCreateVideoAsset.');
            }
            const localVarPath = `/admin/v1/videoAsset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createVideoAssetDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createVideoAssetDTO !== undefined ? createVideoAssetDTO : {}) : (createVideoAssetDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAssetUploadUrl: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/videoAsset/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVideoAsset: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteVideoAsset.');
            }
            const localVarPath = `/admin/v1/videoAsset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [eventId]
         * @param {string} [artistId]
         * @param {string} [venueId]
         * @param {string} [organizationId]
         * @param {string} [search]
         * @param {string} [tags]
         * @param {boolean} [videoAssetIsPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListVideoAssets: (startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/videoAsset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }
            if (videoAssetIsPublic !== undefined) {
                localVarQueryParameter['videoAssetIsPublic'] = videoAssetIsPublic;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateVideoAssetRequest} updateVideoAssetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVideoAsset: (updateVideoAssetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateVideoAssetRequest' is not null or undefined
            if (updateVideoAssetRequest === null || updateVideoAssetRequest === undefined) {
                throw new base_1.RequiredError('updateVideoAssetRequest', 'Required parameter updateVideoAssetRequest was null or undefined when calling adminUpdateVideoAsset.');
            }
            const localVarPath = `/admin/v1/videoAsset/updateVideoAsset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateVideoAssetRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateVideoAssetRequest !== undefined ? updateVideoAssetRequest : {}) : (updateVideoAssetRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VideoAssetsApi - functional programming interface
 * @export
 */
exports.VideoAssetsApiFp = function (configuration) {
    return {
        /**
         *
         * @param {CreateVideoAssetDTO} createVideoAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAsset(createVideoAssetDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.VideoAssetsApiAxiosParamCreator(configuration).adminCreateVideoAsset(createVideoAssetDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAssetUploadUrl(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.VideoAssetsApiAxiosParamCreator(configuration).adminCreateVideoAssetUploadUrl(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVideoAsset(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.VideoAssetsApiAxiosParamCreator(configuration).adminDeleteVideoAsset(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [eventId]
         * @param {string} [artistId]
         * @param {string} [venueId]
         * @param {string} [organizationId]
         * @param {string} [search]
         * @param {string} [tags]
         * @param {boolean} [videoAssetIsPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.VideoAssetsApiAxiosParamCreator(configuration).adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {UpdateVideoAssetRequest} updateVideoAssetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVideoAsset(updateVideoAssetRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.VideoAssetsApiAxiosParamCreator(configuration).adminUpdateVideoAsset(updateVideoAssetRequest, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
/**
 * VideoAssetsApi - factory interface
 * @export
 */
exports.VideoAssetsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {CreateVideoAssetDTO} createVideoAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAsset(createVideoAssetDTO, options) {
            return exports.VideoAssetsApiFp(configuration).adminCreateVideoAsset(createVideoAssetDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAssetUploadUrl(options) {
            return exports.VideoAssetsApiFp(configuration).adminCreateVideoAssetUploadUrl(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVideoAsset(id, options) {
            return exports.VideoAssetsApiFp(configuration).adminDeleteVideoAsset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [eventId]
         * @param {string} [artistId]
         * @param {string} [venueId]
         * @param {string} [organizationId]
         * @param {string} [search]
         * @param {string} [tags]
         * @param {boolean} [videoAssetIsPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options) {
            return exports.VideoAssetsApiFp(configuration).adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateVideoAssetRequest} updateVideoAssetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVideoAsset(updateVideoAssetRequest, options) {
            return exports.VideoAssetsApiFp(configuration).adminUpdateVideoAsset(updateVideoAssetRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VideoAssetsApi - object-oriented interface
 * @export
 * @class VideoAssetsApi
 * @extends {BaseAPI}
 */
class VideoAssetsApi extends base_1.BaseAPI {
    /**
     *
     * @param {VideoAssetsApiAdminCreateVideoAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    adminCreateVideoAsset(requestParameters, options) {
        return exports.VideoAssetsApiFp(this.configuration).adminCreateVideoAsset(requestParameters.createVideoAssetDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    adminCreateVideoAssetUploadUrl(options) {
        return exports.VideoAssetsApiFp(this.configuration).adminCreateVideoAssetUploadUrl(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VideoAssetsApiAdminDeleteVideoAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    adminDeleteVideoAsset(requestParameters, options) {
        return exports.VideoAssetsApiFp(this.configuration).adminDeleteVideoAsset(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VideoAssetsApiAdminListVideoAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    adminListVideoAssets(requestParameters = {}, options) {
        return exports.VideoAssetsApiFp(this.configuration).adminListVideoAssets(requestParameters.startAfter, requestParameters.limit, requestParameters.eventId, requestParameters.artistId, requestParameters.venueId, requestParameters.organizationId, requestParameters.search, requestParameters.tags, requestParameters.videoAssetIsPublic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VideoAssetsApiAdminUpdateVideoAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoAssetsApi
     */
    adminUpdateVideoAsset(requestParameters, options) {
        return exports.VideoAssetsApiFp(this.configuration).adminUpdateVideoAsset(requestParameters.updateVideoAssetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.VideoAssetsApi = VideoAssetsApi;
